const apiVersion = process.env.REACT_APP_API_VERSION ?? "";

export const authApiURL = process.env.REACT_APP_AUTH_API_URL ?? "";

export const baseURL = authApiURL + apiVersion;

export const authLoginURL = authApiURL + apiVersion + "oauth/";
